import { sendAnalytics } from '@audio-network/analytics'
import {
	Button,
	Paragraph,
	Popover,
	TextArea,
} from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'

import { useActiveProject } from '@/hooks/useActiveProject'

import styles from './NotePopover.module.css'
import { NotePopoverProps } from './NotePopover.types'

const NotePopover = ({ id, track }: NotePopoverProps): JSX.Element => {
	const { t } = useTranslation(['trackrow'])
	const { t: appTranslation } = useTranslation(['app'])
	const { project, isEditable, onChangeNotes } = useActiveProject()

	const popoverRef = useRef(null)
	const textAreaRef = useRef(null)

	const note = project?.Tracks?.find((t) => t.Id === track.id)?.Notes

	const handleSubmit = (event: React.FormEvent): void => {
		event.preventDefault()

		const existingNotes = project?.Tracks?.find(
			(projectTrack) => projectTrack.Id === track.id
		)?.Notes

		const newNotes = textAreaRef.current.value

		let action: 'Added' | 'Edited' | 'Deleted' = 'Added'

		if (existingNotes?.length > 0 && newNotes.length > 0) {
			action = 'Edited'
		}

		if (existingNotes?.length && newNotes.length === 0) {
			action = 'Deleted'
		}

		sendAnalytics({
			noun: 'Project Note',
			pastTenseVerb: action,
			eventParameters: {
				ProjectId: project.Id,
				TrackId: track.id,
			},
		})

		onChangeNotes?.(newNotes, track)

		const popover = popoverRef.current as HTMLDivElement

		if ('hidePopover' in HTMLDivElement.prototype) {
			popover.hidePopover()
		}
	}

	return (
		<Popover
			id={id}
			mobileCloseLabel={appTranslation('close')}
			ref={popoverRef}
		>
			{isEditable ? (
				<form className={styles.form} onSubmit={handleSubmit}>
					<TextArea
						label={t('track-actions.notes')}
						name={t('track-actions.notes')}
						rows={4}
						defaultValue={note}
						ref={textAreaRef}
					/>
					<Button size="S" type="submit">
						{t('track-notes.update')}
					</Button>
				</form>
			) : (
				<Paragraph size="S">{note}</Paragraph>
			)}
		</Popover>
	)
}

export default NotePopover
